import styled from "styled-components";

export const Nav = styled.div`
    background-color: ${p => p.theme.c.boost};
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.3);
    transition: height 400ms;
    position: relative;
    z-index: 1;
    svg {
        fill: ${p => p.theme.c.white};
    }

    height: 80px;
`;

export const Logo = styled.div`
    transform: scale(1.7);
    transform-origin: top right;
    padding-top: 3px;
    text-align: right;
`;

export const Message = styled.div`
    height: calc(100vh - 80px);
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${p => p.theme.c.white};
    flex-direction: column;

    .Validation {
        transform: scale(1.7);
    }
`;

export const Center = styled.div`
    text-align: center;
`;

export const StaffLines = styled.div`
    position: absolute;
    right: 171px;
    top: 0;
    pointer-events: none;
    margin-top: 3px;

    display: flex;
    align-items: center;
    svg {
        width: 100vw;
        line {
            stroke: ${p => p.theme.c.snow};
            stroke-width: 1px;
        }
    }
`;
